import * as Commons from "oc-commons/Commons";
import * as _ from "lodash";

const connectorCache = Commons.cache(
  (name: string, figure: string, strengthFactor: number) => new ConnectorType(name, figure, strengthFactor),
);

/**
 * Der Typ eines Connectors, also in erster Linie die Figure: Anchor, Hook, Eyelet, Magnet und ein Typ-Name.
 */
export class ConnectorType {
  name: string;
  figure: string;
  color: string;
  strengthFactor: number;

  static Figures = {
    // Anchor geht eine Verbindung mit dem Boden ein (y=0)
    Anchor: "Anchor",
    // Hook geht eine Verbindung mit einem Eyelet gleichen Typ-Namens ein
    Hook: "Hook",
    // Eyelet geht eine Verbindung mit einem Hook gleichen Typ-Namens ein
    Eyelet: "Eyelet",
    // Magnet geht eine Verbindung mit einem Magnet gleichen Typ-Namens ein
    Magnet: "Magnet",
  };

  /**
   * Ermöglicht optional Kurzschreibweisen für ConnectorTypes als Array
   * Array: [name, figure, strengthFactor]
   * @param {(ConnectorType|Array<string>)} type
   */
  static ensureType(type: ConnectorType | [string, string, number]): ConnectorType {
    return _.isArray(type) ? connectorCache(...type) : type;
  }

  /**
   * Creates an instance of ConnectorType.
   * @param {string} name
   * @param {string} figure
   * @param {number} [strengthFactor=1]
   * @param {string} [color='#ffffff']
   */
  constructor(name: string, figure: string, strengthFactor: number = 1, color: string = "#ffffff") {
    this.name = name;
    this.figure = figure;
    this.color = color;
    this.strengthFactor = strengthFactor;
  }
}
